import { COLORS } from "../../../common/consts/colors";

export type IconProps = {
  color?: keyof typeof COLORS;
  className?: string;
};

export default function BedIcon({ color = "purple", className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M2.49967 5C2.49967 4.53976 2.12658 4.16667 1.66634 4.16667C1.2061 4.16667 0.833008 4.53976 0.833008 5V15.8333C0.833008 16.2936 1.2061 16.6667 1.66634 16.6667C2.12658 16.6667 2.49967 16.2936 2.49967 15.8333V14.1667H17.4997V15.8333C17.4997 16.2936 17.8728 16.6667 18.333 16.6667C18.7932 16.6667 19.1663 16.2936 19.1663 15.8333V8.33333C19.1663 6.95262 18.0471 5.83333 16.6663 5.83333H11.6663C10.2856 5.83333 9.16634 6.95262 9.16634 8.33333V12.5H2.49967V5Z"
        fill={COLORS[color]}
      />
      <path
        d="M5.83301 6.66667C4.4523 6.66667 3.33301 7.78595 3.33301 9.16667C3.33301 10.5474 4.4523 11.6667 5.83301 11.6667C7.21372 11.6667 8.33301 10.5474 8.33301 9.16667C8.33301 7.78595 7.21372 6.66667 5.83301 6.66667Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
